import { Block } from '../../../../../services/entities/impl/blfApi/schemas/block';
import { Ranch } from '../../../../../services/entities/impl/blfApi/schemas/ranch';
import {
  CropTypeEnum,
  Variety,
} from '../../../../../services/entities/impl/blfApi/schemas/variety';

/**
 * Utility function to filter blocks based on various criteria
 * @param blocks - Array of blocks to filter
 * @param filterCustomerID - Customer ID to filter by
 * @param filterRanchID - Ranch ID to filter by
 * @param filteredRanches - Previously filtered ranches
 * @param filterCropType - Crop type to filter by
 * @param varieties - Array of varieties for crop type lookup
 * @returns Filtered array of blocks
 */
export const filterBlocks = (
  blocks: Block[] | undefined,
  filterCustomerID: string,
  filterRanchID: string,
  filteredRanches: Ranch[] | undefined,
  filterCropType: CropTypeEnum | null | undefined,
  varieties: Variety[] | undefined
): Block[] => {
  if (!blocks) return [];

  // Create variety lookup map for performance
  const varietyMap = new Map(varieties?.map((v) => [v.id, v]) || []);

  // First filter the blocks based on the filterRanchID or filterCustomerID if provided
  let blocksFilteredByIDs: Block[] = blocks;
  if (filterRanchID !== '') {
    blocksFilteredByIDs = blocks.filter(
      (block) => block.ranchID === filterRanchID
    );
  } else if (filterCustomerID !== '') {
    // If filterRanchID is not set, then we need to we need to filter the blocks based on the previously filtered ranches since block doesn't have customerID
    const ranchIDs = filteredRanches?.map((ranch) => ranch.id);
    blocksFilteredByIDs = blocks.filter((block) =>
      ranchIDs?.includes(block.ranchID)
    );
  }

  if (filterCropType) {
    blocksFilteredByIDs = blocksFilteredByIDs.filter((block) => {
      const variety = varietyMap.get(block.varietyID);
      return variety?.cropType === filterCropType;
    });
  }

  return blocksFilteredByIDs;
};
